import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const TwitterMetadataEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    card: z.enum(['player', 'summary', 'summary_large_image']),
    site: z.string().optional().nullable(),
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    creator: z.string().optional().nullable(),
    imageUrls: z.array(z.string()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export const LocalizedTwitterMetadataEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.record(z.string(), z.string()),
    card: z.record(z.string(), z.enum(['player', 'summary', 'summary_large_image'])),
    site: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    title: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    description: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    creator: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    imageUrls: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
